import React from 'react';
import ComparisonOverlay from './ComparisonOverlay';
import PropTypes from 'prop-types';

import tick from '../../../../../image/Icons/tick-a805fb.svg';

/**
 * IconComparisonTableMobile.
 * Table for comparing items in a product package.
 *
 * @author  Manny
 * @param   {Array}       props.data            Product package's data.
 * @param   {Object}      props.industryPackage List of packages for the industry.
 * @param   {String}      props.packageKey      Name of the package.
 * @param   {String}      props.type            Type of product package data.
 * @returns {JSX.Element} The component markup.
 */

const IconComparisonTableMobile = ({ data, industryPackage, packageKey, type }) => {
  let dataContent = null;
  const renderTitle = (key, title, description) => {
    return <>
      <div className="flex">
        <div className="column semi-bold title-column"id={key}>
          {title}
        </div>
        <div className="column semi-bold tooltip-column text-right">
          {description && <ComparisonOverlay tooltip={description}/>}
        </div>
      </div>
    </>
  }
  if (data !== undefined) {
    dataContent = Object.keys(data).map(function (singlePackage) {
      let item = data[singlePackage];
      let subItem = industryPackage[packageKey];
      return (
        <div className='row table-padding' key={item.key || singlePackage}>
          <div className='col-xs-9'>
            {renderTitle(`item_title_${item.key}`, item.title, item.description)}
          </div>
          <div className='col-xs-3 comparison-table-align'>
            {subItem.features[type] && subItem.features[type][item.key] === true && (
              <img className="tick-margin" src={tick} alt='yes' />
            )}
            {subItem.features[type] && subItem.features[type][item.key] === 'Except VIC' && (
              <div>
                <img className="tick-margin" src={tick} alt='yes' />
                <div style={{ fontSize: '10px', marginBottom: '-10px' }}>Except VIC</div>
              </div>
            )}
            {subItem.features[type] &&
              typeof subItem.features[type][item.key] === 'string' &&
              subItem.features[type][item.key] !== 'Except VIC' && (
                <span>{subItem.features[type][item.key]}</span>
              )}
            {subItem.features[type] && !subItem.features[type][item.key] && (
              <span>
                <i className='fa fa-minus tan-text' aria-hidden='true'></i>
              </span>
            )}

            {/* If the value is an object */}
            {subItem.features[type] &&
              typeof subItem.features[type][item.key] === 'object' &&
              subItem.features[type][item.key].default && <img className="tick-margin" src={tick} alt='yes' />}
            {subItem.features[type] && typeof subItem.features[type][item.key] === 'object' && (
              <span>{subItem.features[type][item.key].price}</span>
            )}
          </div>
        </div>
      );
    });
  }

  return <div>{dataContent}</div>;
};

IconComparisonTableMobile.propTypes = {
  data: PropTypes.array.isRequired,
  industryPackage: PropTypes.object.isRequired,
  packageKey: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired
};

export default IconComparisonTableMobile;
